export enum ApprovalStatus {
    Rejected = -1,
    Waiting = 0,
    WaitingForApproval = 1,
    Approved = 2,
}